// 引入api
import { fun_PostAction, fun_Download } from "@/api";
//引入下载方法
import { fun_DownloadFile } from "@/utils/validate.js";
// 默认导出
export default {
  data: () => {
    return {
      // 弹窗状态
      dialogVisible: false,
      fileType: "prequalificationFileClarifyType",
      // 答疑列表配置
      tableColumns: [
        {
          label: "附件名称",
          prop: "fileName"
        },
        {
          label: "上传时间",
          prop: "insertDate"
        },
        {
          label: "操作",
          slotName: "op"
        }
      ],
      // 答疑列表数据
      tableData: [],
      // 表格loading
      loading: false
    };
  },
  // 模板编译完成
  mounted() {
    // 获取表格数据
    // this.fun_ListData();
  },
  // 自定义方法
  methods: {
    /**
     * 下载
     * @author liutong
     */
    fun_DownloadFiles(filePath) {
      if (filePath) {
        const form = {
          filePath: filePath
        };
        // 下载文件
        fun_Download("/downloadLocal", form).then(res => {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
          } else {
            fun_DownloadFile(res, Math.random() + ".pdf");
          }
        });
      } else {
        this.$message.error("文件不存在！");
      }
    },
    /**
     * 获取表格数据
     * @author liutong
     */
    async fun_ListData() {
      // 打开表格loading
      this.loading = true;
      // 调用接口
      let res = await fun_PostAction(
        "/fileInfo/fileList?recordNumber=" +
          this.$route.query.id +
          "&fileType=" +
          this.fileType
      );
      // 解构res.data
      const { data, msg, result } = res.data;
      // 请求是否成功
      if (result) {
        // 赋值数据
        this.tableData = data.records;
      } else {
        // 失败提示
        this.$message.error(msg);
      }
      // 关闭表格loading
      this.loading = false;
    }
  }
};
